// React
import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';

// Styles
import '../css/Header.css';

const Header = memo(({
  searchEntityId = '',
  onSearchChange,
  onSearchSubmit,
  searchLoading = false,
  onReportErrorClick,
}) => {
  const location = useLocation();
  const isOnEntitiesScreen = location.pathname === '/entities';

  return (
    <>
      <header className="header-frame">
        <div className="header-row">
          {/* Program Logo & Name */}
          <div className="brand-content" style={{ cursor: 'pointer' }} title="CyberWell Website">
            <a href="https://cyberwell.org/" target="_blank" rel="noreferrer">
              <img src={`${process.env.PUBLIC_URL || ''}/images/cyberwell-logo.png`} alt="CyberWell Logo" className="logo" />
            </a>
          </div>

          {!isOnEntitiesScreen && onSearchChange && onSearchSubmit && (
            <div className="header-search-row">
              <div className="header-search-field">
                <svg className="header-search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                  <circle cx="7.5" cy="7.5" r="5.75" stroke="#303030" strokeWidth="1.5"/>
                  <line x1="12.03" y1="12.03" x2="16" y2="16" stroke="#303030" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
                <input
                  type="search"
                  className="header-search-input"
                  placeholder="Search by platform, IHRA or description..."
                  value={searchEntityId}
                  onChange={(e) => onSearchChange(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      onSearchSubmit();
                    }
                  }}
                  disabled={searchLoading}
                  enterKeyHint="search"
                  aria-label="Search database by user, platform, IHRA, or description"
                />
              </div>
            </div>
          )}

          <div className="header-links">
            <a href="https://cyberwell.org/" target="_blank" rel="noreferrer">Our Website</a>
            <button
              type="button"
              className="header-link-button"
              onClick={onReportErrorClick}
            >
              Report an Error
            </button>
            <a href="https://cyberwell.org/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
            <a href="https://cyberwell.org/terms-of-use/" target="_blank" rel="noreferrer">Terms of Use</a>
          </div>
        </div>
      </header>
    </>
  );
});

Header.displayName = 'Header';

export default Header;
